import axios from 'axios'
import endpoints from '@/api/endpoints'

export default {
  async getNotices () {
    return axios.get(endpoints.notices).then((response) => {
      return response.data
    })
  },
  async createNotice (notice) {
    return axios.post(endpoints.notices, notice).then((response) => {
      return response.data
    })
  },
  async getNotice (noticeID) {
    return axios.get(endpoints.notices + noticeID + '/').then((response) => {
      return response.data
    })
  },
  async updateNotice (notice) {
    console.log(JSON.parse(JSON.stringify(notice)));
    return axios.patch(endpoints.notices + notice.id + '/', notice).then((response) => {
      return response.data
    }).catch(err => {
      console.log(err.response.data);
    });
  },
  async previewNotice (noticeID, obj) {
    // sent - { projects: id of single project, timeline: timelineValue }
    //     the timeline sent in IS NOT SAVED - it's just used temporarily to render the desired output.
    // returned - { name: 'Name of Notice', subject: 'Subject', decription: 'Description', text: 'Formatted text of notice, with @mentions filled in'}
    return axios.patch(endpoints.notices + noticeID + '/preview/', obj).then((response) => {
      return response.data
    })
  },
  async getIrrigationPreviewList () {
    return axios.get(endpoints.irrigationPreviewList).then((response) => {
      return response.data
    })
  },
  async getSnowPreviewList () {
    return axios.get(endpoints.snowPreviewList).then((response) => {
      return response.data
    })
  },
  async getLawnPreviewList(){
    return axios.get(endpoints.lawnPreviewList).then((response) => {
      return response.data;
    })
  }
}